import React from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'

const RichTextDisplay = ({ value }) => {
    return (
        <div className="rich-text-display">
            <ReactQuill
                value={value || '<p>N/A</p>'}
                readOnly={true}
                theme="bubble"
                modules={{ toolbar: false }}
            />
        </div>
    )
}

export default RichTextDisplay

